import { AppointmentsService } from "./../../services/appointments/appointments.service";
import { Component, OnInit } from "@angular/core";
import { AppService } from "../../services/app.service";
import { ToastrService } from "ngx-toastr";
import { UsersService } from "src/app/services/users/users.service";

@Component({
    selector: "app-programari-list",
    templateUrl: "./programari-list.component.html",
    styleUrls: ["./programari-list.component.scss"],
})
export class ProgramariListComponent implements OnInit {
    appointments: any[] = [];
    message: string | null = null;

    // filtre
    startDate: string = "";
    endDate: string = "";

    startDateView!: Date; // pentru UI
    endDateView!: Date; // pentru UI

    specialtyCode: string = "";

    loading = false;

    constructor(
        private appointmentsService: AppointmentsService,
        private appService: AppService,
        private usersService: UsersService,
        private toastr: ToastrService,
    ) {}

    ngOnInit(): void {
        const today = new Date();
        const past = new Date();
        past.setDate(today.getDate() - 30);

        this.startDate = this.formatDateParam(past);
        this.endDate = this.formatDateParam(today);

        this.startDateView = past;
        this.endDateView = today;

        this.loadItems();
    }

    private formatDateParam(d: Date): string {
        const y = d.getFullYear();
        const m = (d.getMonth() + 1).toString().padStart(2, "0");
        const day = d.getDate().toString().padStart(2, "0");
        return `${y}${m}${day}`;
    }

    loadItems(): void {
        this.loading = true;
        this.message = "Lista se încarcă...";

        this.usersService
            .getMyAppointments() // ← paranteze!
            .subscribe({
                next: (data: any[]) => {
                    this.appointments = (data || []).sort(
                        (a, b) =>
                            new Date(b.startDate).getTime() -
                            new Date(a.startDate).getTime(),
                    );
                    this.message = this.appointments.length
                        ? null
                        : "Nu ai programări în perioada selectată.";
                    this.loading = false;
                },
                error: () => {
                    this.loading = false;
                    this.appointments = [];
                    this.message =
                        "A apărut o eroare la încărcarea programărilor.";
                    this.toastr.error(this.message, "Programări");
                },
            });
    }

    getActiveAppointments(appointments: any[]): any[] {
        if (!appointments) {
            this.message = "Nu ai programări active.";
            return [];
        }
        const result: any[] = [];
        const now = Date.now();

        appointments.forEach((a) => {
            const status = this.getStatus(a);
            if (status === "Activa") {
                // numerotare
                a.nrCrt = result.length + 1;
                result.push(a);
            }
        });

        if (!result.length) {
            this.message = "Nu ai programări active.";
        } else {
            this.message = null;
        }

        return result;
    }

    getHistoryAppointments(appointments: any[]): any[] {
        if (!appointments) {
            this.message = "Nu ai programări.";
            return [];
        }

        const result: any[] = [];

        appointments.forEach((a) => {
            const status = this.getStatus(a);
            if (status !== "Activa") {
                result.push(a);
            }
        });

        if (!result.length) {
            this.message = "Nu ai programări în istoric.";
        } else {
            this.message = null;
        }

        return result;
    }

    /** determină statusul textual pe baza status + timp */
    getStatus(appointment: any): string {
        if (!appointment) {
            return "";
        }

        const status = (appointment.status || "").toLowerCase();
        const date = new Date(appointment.startDate);
        // suprascriem ora cu startHour "HH:mm"
        if (appointment.startHour) {
            const [h, m] = appointment.startHour.split(":").map(Number);
            date.setHours(h, m, 0, 0);
        }

        const now = Date.now();
        const appointmentTime = date.getTime();

        if (appointmentTime > now) {
            return "Activa";
        }

        if (status === "active") {
            return "Neonorata";
        }
        if (status === "efectuat") {
            return "Onorata";
        }

        return status || "Necunoscut";
    }

    cancel(appt: any): void {
        // Confirmă înainte de anulare
        if (
            !confirm(
                `Sigur dorești să anulezi programarea cu Dr. ${appt.doctorName}?`,
            )
        ) {
            return;
        }

        const cancelData = {
            eventId: appt.event.uid,
            scheduleId: appt.schedule.uid,
        };

        this.usersService.cancelAppointment(cancelData).subscribe({
            next: () => {
                // Succes - reîncarcă lista de programări
                this.loadItems();

                // Mesaj de succes (dacă ai toastr)
                this.toastr?.success(
                    "Programarea a fost anulată cu succes",
                    "Anulare programare",
                );

                console.log("✅ Appointment canceled");
            },
            error: (err) => {
                // Eroare - afișează mesaj
                this.toastr?.error(
                    "Eroare la anularea programării. Încercați din nou.",
                    "Eroare",
                );

                console.error("❌ Cancel appointment error:", err);
            },
        });
    }
}
